import React from 'react';
import PagarLinkifyButton from './PagarLinkifyButton';
import { useAuth } from '../../context/AuthContext'; // o donde tengas el usuario logueado

export default function PagosPaciente() {
  const { user } = useAuth();

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Pagos pendientes</h1>

      <PagarLinkifyButton
        pacienteId={user.uid}
        montoCLP={15000}
        descripcion="Sesión de kinesiología 45 min"
      />
    </div>
  );
}
